import { CSSObject, Theme } from '@mui/material';

const genOpenedMixin =
  (drawerWidth: number | string) =>
  (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  });

const genClosedMixin =
  () =>
  (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.down('lg')]: {
      width: 0,
    },
  });

export { genClosedMixin, genOpenedMixin };
